"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DOMException = require("domexception/webidl2js-wrapper");

var _require = require("whatwg-url"),
    serializeURL = _require.serializeURL;

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var _require3 = require("../helpers/events"),
    fireAnEvent = _require3.fireAnEvent;

var _require4 = require("../helpers/form-controls"),
    formOwner = _require4.formOwner,
    isListed = _require4.isListed,
    isSubmittable = _require4.isSubmittable,
    isSubmitButton = _require4.isSubmitButton;

var HTMLCollection = require("../generated/HTMLCollection");

var notImplemented = require("../../browser/not-implemented");

var _require5 = require("../helpers/document-base-url"),
    parseURLToResultingURLRecord = _require5.parseURLToResultingURLRecord;

var encTypes = new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
var methods = new Set(["get", "post", "dialog"]);
var constraintValidationPositiveResult = Symbol("positive");
var constraintValidationNegativeResult = Symbol("negative");

var HTMLFormElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLFormElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLFormElementImpl);

  function HTMLFormElementImpl() {
    _classCallCheck(this, HTMLFormElementImpl);

    return _super.apply(this, arguments);
  }

  _createClass(HTMLFormElementImpl, [{
    key: "_descendantAdded",
    value: function _descendantAdded(parent, child) {
      var form = this;

      var _iterator = _createForOfIteratorHelper(domSymbolTree.treeIterator(child)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;

          if (typeof el._changedFormOwner === "function") {
            el._changedFormOwner(form);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _get(_getPrototypeOf(HTMLFormElementImpl.prototype), "_descendantAdded", this).call(this, parent, child);
    }
  }, {
    key: "_descendantRemoved",
    value: function _descendantRemoved(parent, child) {
      var _iterator2 = _createForOfIteratorHelper(domSymbolTree.treeIterator(child)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var el = _step2.value;

          if (typeof el._changedFormOwner === "function") {
            el._changedFormOwner(null);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      _get(_getPrototypeOf(HTMLFormElementImpl.prototype), "_descendantRemoved", this).call(this, parent, child);
    }
  }, {
    key: "_getElementNodes",
    value: function _getElementNodes() {
      var _this = this;

      return domSymbolTree.treeToArray(this.getRootNode({}), {
        filter: function filter(node) {
          if (!isListed(node) || node._localName === "input" && node.type === "image") {
            return false;
          }

          return formOwner(node) === _this;
        }
      });
    } // https://html.spec.whatwg.org/multipage/forms.html#dom-form-elements

  }, {
    key: "elements",
    get: function get() {
      var _this2 = this;

      // TODO: Return a HTMLFormControlsCollection
      return HTMLCollection.createImpl(this._globalObject, [], {
        element: this.getRootNode({}),
        query: function query() {
          return _this2._getElementNodes();
        }
      });
    }
  }, {
    key: "length",
    get: function get() {
      return this.elements.length;
    }
  }, {
    key: "_doSubmit",
    value: function _doSubmit() {
      if (!this.isConnected) {
        return;
      }

      this.submit();
    }
  }, {
    key: "submit",
    value: function submit() {
      if (!fireAnEvent("submit", this, undefined, {
        bubbles: true,
        cancelable: true
      })) {
        return;
      }

      notImplemented("HTMLFormElement.prototype.submit", this._ownerDocument._defaultView);
    }
  }, {
    key: "requestSubmit",
    value: function requestSubmit() {
      var submitter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (submitter !== undefined) {
        if (!isSubmitButton(submitter)) {
          throw new TypeError("The specified element is not a submit button");
        }

        if (submitter.form !== this) {
          throw DOMException.create(this._globalObject, ["The specified element is not owned by this form element", "NotFoundError"]);
        }
      }

      if (!fireAnEvent("submit", this, undefined, {
        bubbles: true,
        cancelable: true
      })) {
        return;
      }

      notImplemented("HTMLFormElement.prototype.requestSubmit", this._ownerDocument._defaultView);
    }
  }, {
    key: "_doReset",
    value: function _doReset() {
      if (!this.isConnected) {
        return;
      }

      this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!fireAnEvent("reset", this, undefined, {
        bubbles: true,
        cancelable: true
      })) {
        return;
      }

      var _iterator3 = _createForOfIteratorHelper(this.elements),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var el = _step3.value;

          if (typeof el._formReset === "function") {
            el._formReset();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "method",
    get: function get() {
      var method = this.getAttributeNS(null, "method");

      if (method) {
        method = method.toLowerCase();
      }

      if (methods.has(method)) {
        return method;
      }

      return "get";
    },
    set: function set(V) {
      this.setAttributeNS(null, "method", V);
    }
  }, {
    key: "enctype",
    get: function get() {
      var type = this.getAttributeNS(null, "enctype");

      if (type) {
        type = type.toLowerCase();
      }

      if (encTypes.has(type)) {
        return type;
      }

      return "application/x-www-form-urlencoded";
    },
    set: function set(V) {
      this.setAttributeNS(null, "enctype", V);
    }
  }, {
    key: "action",
    get: function get() {
      var attributeValue = this.getAttributeNS(null, "action");

      if (attributeValue === null || attributeValue === "") {
        return this._ownerDocument.URL;
      }

      var urlRecord = parseURLToResultingURLRecord(attributeValue, this._ownerDocument);

      if (urlRecord === null) {
        return attributeValue;
      }

      return serializeURL(urlRecord);
    },
    set: function set(V) {
      this.setAttributeNS(null, "action", V);
    } // If the checkValidity() method is invoked, the user agent must statically validate the
    // constraints of the form element, and return true if the constraint validation returned
    // a positive result, and false if it returned a negative result.

  }, {
    key: "checkValidity",
    value: function checkValidity() {
      return this._staticallyValidateConstraints().result === constraintValidationPositiveResult;
    } // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#interactively-validate-the-constraints

  }, {
    key: "reportValidity",
    value: function reportValidity() {
      return this.checkValidity();
    } // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#statically-validate-the-constraints

  }, {
    key: "_staticallyValidateConstraints",
    value: function _staticallyValidateConstraints() {
      var controls = [];

      var _iterator4 = _createForOfIteratorHelper(this.elements),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var el = _step4.value;

          if (el.form === this && isSubmittable(el)) {
            controls.push(el);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var invalidControls = [];

      for (var _i = 0, _controls = controls; _i < _controls.length; _i++) {
        var control = _controls[_i];

        if (control._isCandidateForConstraintValidation() && !control._satisfiesConstraints()) {
          invalidControls.push(control);
        }
      }

      if (invalidControls.length === 0) {
        return {
          result: constraintValidationPositiveResult
        };
      }

      var unhandledInvalidControls = [];

      for (var _i2 = 0, _invalidControls = invalidControls; _i2 < _invalidControls.length; _i2++) {
        var invalidControl = _invalidControls[_i2];
        var notCancelled = fireAnEvent("invalid", invalidControl, undefined, {
          cancelable: true
        });

        if (notCancelled) {
          unhandledInvalidControls.push(invalidControl);
        }
      }

      return {
        result: constraintValidationNegativeResult,
        unhandledInvalidControls: unhandledInvalidControls
      };
    }
  }]);

  return HTMLFormElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLFormElementImpl
};